import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { CircularProgress, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import AddWorkoutCalenderClient from "../Calender/AddWorkoutCalenderClient";
import { memberDetailApi } from "src/DAL/member/Member1";
import { programme_detail_api } from "src/DAL/Programme/Programme";
import moment from "moment";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function WorkoutEditFullPage() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { id, CalId, workoutId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [workoutData, setWorkoutData] = useState(null);
  const [programmeData, setProgrammeData] = useState(null);
  const [memberData, setMemberData] = useState(null);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const childRef = React.useRef();
  console.info(id, CalId, workoutId);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      enqueueSnackbar("Please log in to access this page", {
        variant: "warning",
      });
      navigate("/login");
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);

        if (CalId) {
          const programResult = await programme_detail_api(CalId);
          if (programResult.code === 200) {
            setProgrammeData(programResult.program);
          } else {
            enqueueSnackbar(programResult.message, { variant: "error" });
            navigate("/dashboard");
          }
        }

        if (workoutId) {
          const searchParams = new URLSearchParams(location.search);
          const workoutDateParam =
            searchParams.get("date") || location.state?.workout_date;
          const baseDate =
            workoutDateParam && moment(workoutDateParam).isValid()
              ? moment(workoutDateParam)
              : moment();
          const startDate = baseDate.clone().subtract(30, "days");
          const endDate = baseDate.clone().add(30, "days");

          const postData = {
            start_date: startDate.format("YYYY-MM-DD"),
            end_date: endDate.format("YYYY-MM-DD"),
            program: CalId,
          };

          const result = await memberDetailApi(id, postData);
          console.info(result, "resultresultresult");
          if (result.code === 200) {
            const mergedData = [
              ...result?.workouts,
              ...result?.program_workouts,
            ];

            console.info(mergedData, "mergedDatamergedData");

            const workout = mergedData.find((w) => w._id === workoutId);

            if (workout) {
              setWorkoutData(workout);
              setMemberData(result?.member_info);

              const newQuestions = workout?.questions || [];
              if (newQuestions && newQuestions.length > 0) {
                setQuestionsToSend(newQuestions);
                setEditShow(newQuestions.map(() => ({ display: false })));
              }
            } else {
              enqueueSnackbar("Workout not found", { variant: "error" });
              navigate("/dashboard");
            }
          } else {
            enqueueSnackbar(result.message, { variant: "error" });
            navigate("/dashboard");
          }
        }
      } catch (error) {
        enqueueSnackbar("Error loading workout data", { variant: "error" });
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id, CalId, workoutId, location.search, enqueueSnackbar, navigate]);

  const handleSave = () => {
    if (childRef.current) {
      childRef.current.childButtonClickUpdate();
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  const reloadList = (reloadId, message) => {
    if (message) {
      enqueueSnackbar(message, { variant: "success" });
    }
  };

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  if (!workoutData) {
    return (
      <div className="container-fluid">
        <div className="row mobile-margin display-flex">
          <div className="col-12"></div>
        </div>
        <div className="row section-space">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
              <h1 className="programmes-heading ms-2">Workout not found</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row mobile-margin display-flex">
        <div className="col-12"></div>
      </div>

      <div className="row section-space">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <IconButton onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton>
          </div>
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12">
          <AddWorkoutCalenderClient
            setIsLoading={setIsSaving}
            ref={childRef}
            date={workoutData?.workout_date}
            programme={programmeData}
            member_id={id}
            setOpen={() => navigate(-1)}
            editData={workoutData}
            day={moment(workoutData?.workout_date).format("dddd")}
            events={[]}
            setEvents={() => {}}
            reloadList={reloadList}
            setModalChangeExe={() => {}}
            member_vdot={memberData?.vdot?.vdot_value || null}
            member_vdot_info={memberData?.vdot || null}
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
          />
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12">
          {workoutData?.workout_has_logs ? (
            <button
              disabled={isSaving}
              onClick={isSaving ? null : handleSave}
              className="small-contained-button"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          ) : (
            <>
              {workoutData?.practice_type !== "workbook" ||
              questionsToSend.length > 0 ? (
                <button
                  disabled={isSaving}
                  onClick={isSaving ? null : handleSave}
                  className="small-contained-button"
                >
                  {isSaving ? "Saving..." : "Save"}
                </button>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorkoutEditFullPage;
